module.exports = __webpack_public_path__ + "static/img/newsletter-header.0bb7fad.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newsletter-header.png
// module id = 6XfH
// module chunks = 1